import { useMemo, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ChevronLeft, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/social-planner`;
const WD = ["Lu", "Ma", "Mi", "Jo", "Vi", "Sâ", "Du"];
const roDate = (iso) => new Date(iso).toLocaleDateString("sv-SE", { timeZone: "Europe/Bucharest" });

export const PostCalendar = ({ queue, history, reload }) => {
  const [ym, setYm] = useState(() => new Date().toISOString().slice(0, 7));
  const [drag, setDrag] = useState(null);
  const [y, m] = ym.split("-").map(Number);
  const cells = useMemo(() => {
    const first = new Date(y, m - 1, 1);
    const pad = (first.getDay() + 6) % 7;
    const n = new Date(y, m, 0).getDate();
    return [...Array(pad).fill(null), ...Array.from({ length: n }, (_, i) => `${ym}-${String(i + 1).padStart(2, "0")}`)];
  }, [ym, y, m]);
  const today = roDate(new Date().toISOString());
  const byDay = {};
  (history || []).forEach((h) => { const k = roDate(h.timestamp); (byDay[k] ||= []).push({ kind: "past", h }); });
  (queue || []).forEach((q) => { (byDay[q.slot_key] ||= []).push({ kind: q.status, q }); });
  const shift = (d) => { const t = new Date(y, m - 1 + d, 1); setYm(`${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}`); };
  const drop = async (key) => {
    const q = drag; setDrag(null);
    if (!q || key === q.slot_key) return;
    try { await axios.put(`${API}/queue/${q.id}/date`, { slot_key: key }); toast.success(`Mutată pe ${key}, la aceeași oră`); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };

  return (
    <div className="space-y-3" data-testid="post-calendar">
      <div className="flex items-center gap-2">
        <button data-testid="cal-prev" onClick={() => shift(-1)} className="rounded-full border border-zinc-700 p-1 text-zinc-300"><ChevronLeft className="h-4 w-4" /></button>
        <p className="w-40 text-center text-sm font-medium capitalize text-zinc-100" data-testid="cal-month">{new Date(y, m - 1, 1).toLocaleDateString("ro-RO", { month: "long", year: "numeric" })}</p>
        <button data-testid="cal-next" onClick={() => shift(1)} className="rounded-full border border-zinc-700 p-1 text-zinc-300"><ChevronRight className="h-4 w-4" /></button>
        <span className="text-xs text-zinc-500">Trage o postare programată pe altă zi ca s-o muți (păstrează ora; ora o schimbi din „Oră și dată”).</span>
      </div>
      <div className="grid grid-cols-7 gap-1.5">
        {WD.map((w) => <p key={w} className="text-center text-[11px] text-zinc-500">{w}</p>)}
        {cells.map((k, i) => !k ? <div key={`e${i}`} /> : (
          <div key={k} data-testid={`cal-day-${k}`} onDragOver={(e) => k > today && e.preventDefault()} onDrop={() => drop(k)}
            className={`min-h-[92px] rounded-lg border p-1.5 ${k === today ? "border-amber-400/70" : "border-zinc-800"} ${drag && k > today ? "bg-amber-400/5" : "bg-zinc-900/40"}`}>
            <p className="text-[11px] text-zinc-500">{Number(k.slice(8))}</p>
            {(byDay[k] || []).map((x, j) => x.kind === "past" ? (
              <a key={j} href={x.h.fb_url || x.h.ig_url || "#"} target="_blank" rel="noreferrer" className={`mt-1 block truncate rounded px-1 py-0.5 text-[10px] ${x.h.success ? "bg-emerald-500/15 text-emerald-200" : "bg-rose-500/15 text-rose-200"}`}>✓ {x.h.product_title}</a>
            ) : x.kind === "planned" ? (
              <div key={j} draggable onDragStart={() => setDrag(x.q)} data-testid={`cal-planned-${x.q.id}`} title="Trage pe altă zi"
                className="mt-1 cursor-grab truncate rounded bg-amber-400 px-1 py-0.5 text-[10px] font-medium text-zinc-950 active:cursor-grabbing">{x.q.post_type === "review" ? "★ " : x.q.post_type === "tip" ? "💡 " : x.q.post_type === "seasonal" ? "🎁 " : ""}{x.q.title || x.q.product_title}</div>
            ) : (
              <p key={j} className="mt-1 truncate rounded bg-zinc-800 px-1 py-0.5 text-[10px] text-zinc-400 line-through">{x.q.title || x.q.product_title}</p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
